import {ReduxStateType} from '../store';

export const selectUser = (state: ReduxStateType) => state.user;
